import { SearchType } from 'modules/search/types/SearchType';

export const searchTypes = [
  'ALL',
  'JOB',
  'INTERNSHIP',
  'VOLOP',
  'EVENT',
  'ORG',
] satisfies SearchType[];
